import React from "react";
import "./Footer.css";

const FooterHome = () => {
  return (
    <div style={{ backgroundColor: "#f8fcfd" }}>
      <div
        style={{
          height: "200px",
          width: "80%",
          backgroundColor: "#f8fcfd",
          margin: "auto",
          marginTop: "30px",
          color: "#6c757d",
          fontSize: "13px",
        }}
      >
        <p>
          To access and use all the features of Apple Card, you must add Apple
          Card to Wallet on an iPhone or iPad with the latest version of iOS or
          iPadOS. Update to the latest version by going to Settings &gt; General
          &gt; Software Update. Tap Download and Install.
        </p>
        <br />
        <p> Available for qualifying applicants in the United States.</p>
        <br />
        <p>
          Apple Card is issued by Goldman Sachs Bank USA, Salt Lake City Branch.
        </p>
        <br />
        <p>
          Learn more about how Apple Card applications are evaluated at
          support.apple.com/kb/HT209218.
        </p>
      </div>
      <hr style={{ width: "80%", margin: "auto" }} />
      <div className="footer-container">
        <div className="footer-col">
          <h3>Shop and Learn</h3>
          <p>Store</p>
          <p>Mac</p>
          <p>iPad</p>
          <p>iPhone</p>
          <p>Watch</p>
          <p>AirPods</p>
          <p>TV&Home</p>
          <p>Air Tag</p>
          <p>Accessories</p>
          <p>Gift Cards</p>
       
        </div>
        <div className="footer-col">
          <h3>Services</h3>
          <p>Apple Music</p>
          <p>Apple TV+</p>
          <p>Apple Fitness+</p>
          <p>Apple News+</p>
          <p>Apple Arcade</p>
          <p>iCloud</p>
          <p>Apple One</p>
          <p>Apple Card</p>
          <p>Apple Books</p>
          <p>Apple Podcast</p>
        </div>
        <div className="footer-col">
          <h3>Apple Store</h3>
          <p>Find a Store</p>
          <p>Genius Bar</p>
          <p>Today at Apple</p>
          <p>Apple Camp</p>
          <p>Financing</p>
          <p>Store App</p>
          <p>Refurbished</p>
          <p>Clearance</p>
          <p>Order Status</p>
          <p>Shopping Help</p>
        
        </div>
        <div className="footer-col">
          <h3>For Business</h3>
          <p>Apple Business</p>
          <p>Shop for Business</p>
          <br />
         <h3>For Education</h3>
         <p>Apple Education</p>
         <p>Shop for K-12</p>
         <p>Shop For College</p>
        <br />
        <br />
        </div>
        <div className="footer-col">
          <h3>Apple Values</h3>
          <p>Accessibility</p>
          <p>Education</p>
          <p>environment</p>
          <p>Privacy</p>
          <br />
          <h3>About Apple</h3>
          <p>Newsroom</p>
          <p>Apple Leadership</p>
          <p>Investors</p>
          <p>Contact Apple</p>
        </div>
        
      </div>
      <br />
      <br />
      <p className="footer-blue-line">Find an Apple Store or other retailer near you. Or call 1-800-MY-APPLE</p>
      <br />
      <hr style={{ width: "80%", margin: "auto" }} />
      <p></p>
      <div style={{width: "80%",margin: "auto", display:'flex',justifyContent:"space-between",paddingBottom:'50px',fontSize:"13px"}}>
        <p>Copyright © 2023 Apple Inc. All rights reserved.</p>
        <p>United States</p>
      </div>
    </div>
  );
};

export default FooterHome;
